<template>
  <div class="hm-reslist-item">
    <router-link :to="{name: 'hotel-management-reservations-detail-reservation', params: { id: res.id }}" class="hm-reslist-item__link">
      <span class="hm-reslist-item__id">{{ indexNum + 1 }}.</span>
      <div
        class="hm-reslist-item__status"
        :style="{color: res.status.color, backgroundColor: `rgb(from ${res.status.color} r g b / 0.12)`}"
      >
        {{ res.status.name }}
      </div>
      <span class="hm-reslist-item__name">{{ res.group_name }}</span>
      <div v-if="res.deadline?.date" class="hm-reslist-item__deadline">
        <span class="hm-reslist-item__text">Deadline:</span>
        <div class="hm-reslist-item__deadline-value" :class="deadlineBadgeClass">{{ fmtDate(res.deadline.date) }}</div>
      </div>
    </router-link>
    <div @click="drop_open = !drop_open" class="hm-reslist-item__bottom" :class="{'hm-reslist-item__bottom--disabled': !res.short_rooms.length}" >
      <span class="hm-reslist-item__name">{{ res.source.name }}</span>
      <div v-if="res.start_date && res.end_date" class="hm-reslist-item__interval">
        <span class="hm-reslist-item__text">Interval:</span>
        <div class="hm-reslist-item__dates">
          <CalendarIcon aria-hidden="true"/>
          <span class="hm-reslist-item__date">{{ fmtDate(res.start_date) }}</span>
          <ArrowIcon aria-hidden="true"/>
          <span class="hm-reslist-item__date">{{ fmtDate(res.end_date) }}</span>
        </div>
      </div>
      <span v-else></span>
      <HMChip
        v-if="res.meal_plan"
        :color="res.meal_plan.color"
        isMeal
      >
        {{ res.meal_plan.name }}
      </HMChip>
      <span v-else></span>
      <span></span>
      <ArrowDownIcon aria-hidden="true" class="hm-reslist-item__toogler" :class="{'hm-reslist-item__toogler--open': drop_open}"/>
    </div>
    <transition name="slide-block">
      <div v-if="drop_open" class="hm-reslist-item__dropdown">
        <div
          v-for="(room, index) in res.short_rooms"
          :key="room.id"
          class="hm-reslist-item__room">
          <div class="hm-reslist-item__room-left">
            <div class="hm-reslist-item__room-grid">
              <span class="hm-reslist-item__room-num">{{ index + 1 }}.</span>
              <span class="hm-reslist-item__room-name">{{ room.room_category.name }}</span>
              <div class="hm-reslist-item__dates">
                <CalendarIcon aria-hidden="true"/>
                <span class="hm-reslist-item__date">{{ fmtDate(room.check_in) }}</span>
                <ArrowIcon aria-hidden="true"/>
                <span class="hm-reslist-item__date">{{ fmtDate(room.check_out) }}</span>
              </div>
            </div>
            <div class="hm-reslist-item__room-grid">
              <span></span>
              <div class="hm-reslist-item__room-chips">
                <span class="hm-reslist-item__text" style="font-size: 12px;">Guests:</span>
                <HMChipList>
                  <HMChip v-if="room.accomodation_type?.age_assignment?.adult" color="#9AB992">
                    {{ room.accomodation_type.age_assignment.adult }}
                    <template #icon><AdultIcon aria-hidden="true" /></template>
                  </HMChip>
                  <HMChip v-if="room.accomodation_type?.age_assignment?.teenager" color="#76A9B4">
                    {{ room.accomodation_type.age_assignment.teenager }}
                    <template #icon><TeenagerIcon aria-hidden="true" /></template>
                  </HMChip>
                  <HMChip v-if="room.accomodation_type?.age_assignment?.child" color="#D493B0">
                    {{ room.accomodation_type.age_assignment.child }}
                    <template #icon><ChildIcon aria-hidden="true" /></template>
                  </HMChip>
                </HMChipList>
              </div>
              <div class="hm-reslist-item__room-chips">
                <span class="hm-reslist-item__text" style="font-size: 12px;margin-right: 10px;">Nights:</span>
                <HMChip>
                  {{ room.nights || '0' }}
                  <template #icon><NightsIcon aria-hidden="true" /></template>
                </HMChip>
                <HMChip
                  v-if="res.meal_plan"
                  :color="res.meal_plan.color"
                  isMeal
                >
                  {{ res.meal_plan.name }}
                </HMChip>
              </div>
            </div>
          </div>
          <div class="hm-reslist-item__room-right">
            <div class="hm-reslist-item__room-count" :aria-label="`Rooms: ${ room.count }`">x{{ room.count }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CalendarIcon from '@/views/hotel-management/reservations/detail/icons/CalendarIcon.vue'
import ArrowIcon from '@/views/hotel-management/reservations/detail/icons/ArrowIcon.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import ArrowDownIcon from '@/views/hotel-management/reservations/detail/icons/ArrowDownIcon.vue'
import TeenagerIcon from '@/views/hotel-management/reservations/detail/icons/TeenagerIcon.vue'
import ChildIcon from '@/views/hotel-management/reservations/detail/icons/ChildIcon.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import AdultIcon from '@/views/hotel-management/reservations/detail/icons/AdultIcon.vue'
import HMChipList from '@/views/hotel-management/reservations/components/HMChipList.vue'

export default {
  name: 'HMResListItem',
  components: {
    HMChipList,
    AdultIcon,
    NightsIcon,
    ChildIcon,
    TeenagerIcon,
    ArrowDownIcon,
    HMChip,
    ArrowIcon,
    CalendarIcon
  },
  props: {
    indexNum: {
      type: Number,
    },
    res: {
      type: Object,
    }
  },
  data() {
    return {
      drop_open: false,
    }
  },
  computed: {
    deadlineBadgeClass () {
      const st = (this.res.deadline && this.res.deadline.status) || 'ok'
      return `hm-reslist-item__deadline-value--${st}`
    }
  },
  methods: {
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(`${ iso }T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }, ${ d.getFullYear() }`
    },
  },
  calculateBgColor(color) {

  },
}
</script>

<style scoped>
.hm-reslist-item {
  max-width: 733px;
  margin-bottom: 20px;
  border: 1px solid #E9E9E9;
  border-radius: 16px;
  background-color: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);

  &:last-child {
    margin-bottom: 0;
  }
}

.hm-reslist-item__link {
  display: grid;
  align-items: center;
  grid-template-columns: 34px 226px 1fr max-content;
  height: 60px;
  padding: 0 18px 0 24px;
  border-radius: 16px 16px 0 0;
  border-bottom: 1px solid #E9E9E9;
  transition: background-color 0.3s;

  &:hover {
    background-color: #FBFBFB;
  }
}

.hm-reslist-item__id {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.hm-reslist-item__name {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.hm-reslist-item__deadline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.hm-reslist-item__text {
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.52px;
  text-transform: uppercase;
}

.hm-reslist-item__deadline-value {
  flex-shrink: 0;
  padding: 5px;
  border-radius: 6px;
  background-color: #F6F6F6;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.hm-reslist-item__deadline-value--ok {
  color: #000;
  background: #F6F6F6;
}

.hm-reslist-item__deadline-value--expiring {
  color: #C88C00;
  background: #FAF3E0;
}

.hm-reslist-item__deadline-value--expired {
  color: #CE6A54;
  background: #FFF1EC;
}

.hm-reslist-item__bottom {
  display: grid;
  align-items: center;
  grid-template-columns: 260px 1fr 46px 15px 10px;
  height: 60px;
  padding: 0 18px 0 24px;
  border-radius: 0 0 16px 16px;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.hm-reslist-item__bottom--disabled {
  pointer-events: none;
}

.hm-reslist-item__status {
  max-width: max-content;
  padding: 6px 11px;
  border-radius: 30px;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-transform: capitalize;
}

.hm-reslist-item__interval {
  display: flex;
  align-items: center;
  gap: 10px
}

.hm-reslist-item__dates {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
}

.hm-reslist-item__toogler {
  height: 6px;
  transition: transform 0.3s;
}

.hm-reslist-item__toogler--open {
  transform: rotate(180deg);
}

.hm-reslist-item__dropdown {
  border-top: 1px solid #E9E9E9;
  padding: 0 24px;
}

.hm-reslist-item__room-grid {
  display: grid;
  grid-template-columns: 34px 226px 1fr;
  align-items: center;
}

.hm-reslist-item__room-num {
  color: #707070;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 15px;
  font-weight: 600;
}

.hm-reslist-item__room-name {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.hm-reslist-item__room-chips {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hm-reslist-item__room {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #E9E9E9;

  &:last-child {
    border: none;
  }
}

.hm-reslist-item__room-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hm-reslist-item__room-count {
  width: 46px;
  height: 40px;
  border-radius: 6px;
  background: #f6f6f6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #383838;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.slide-block-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-block-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-block-enter-to, .slide-block-leave {
  max-height: 500px;
  overflow: hidden;
}

.slide-block-enter, .slide-block-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>